var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Selector',_vm._b({staticClass:"dic-selector",attrs:{"multiple":_vm.multiple,"bitwise":_vm.bitwise,"data":_vm.data},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'Selector',_vm.__props,false))}
var staticRenderFns = []

export { render, staticRenderFns }